"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBidStatus = void 0;
var ProductBidStatus;
(function (ProductBidStatus) {
    ProductBidStatus["Submitted"] = "Submitted";
    ProductBidStatus["Won"] = "Won";
    ProductBidStatus["Lost"] = "Lost";
    ProductBidStatus["Cancelled"] = "Cancelled";
})(ProductBidStatus || (exports.ProductBidStatus = ProductBidStatus = {}));
